import InventoryHeader from "./Header";
import "./index.css";
import { useEffect, useState } from "react";
import { ShowHide } from "../components/ShowHideCompany";
import InventoryCustom from "./InventoryCustom";
import InventoryVehicle from "./InventoryVehicle";
import InventoryMachinery from "./InventoryMachinery";
import InventoryBuilding from "./InventoryBuilding";
import InventoryPurchasedService from "./InventoryService";
import InventoryIngoingPackaging from "./InventoryPackagings/IngoingPackaging";
import InventoryPurchasedPackaging from "./InventoryPackagings/PurchasedPackaging";
import InventoryChemical from "./InventoryChemical";
import { getInventory } from "../../../../apis/Business/InventoryApi";
import DropdownAndAutocomplete from "../../../../components/DropdownAutocomplete";
import FlowNumbersBox from "../components/FlowNumbersBox";
import EPRBox from "../components/EPRBox";
const InventoryComponent = ({ businessId, mainBusinessId }) => {
  const [show, setShow] = useState(false);
  const [inventoryData, setInventoryData] = useState([]);
  useEffect(() => {
    getInventory({
      businessId: businessId,
      setObjects: setInventoryData,
    });
  }, [businessId]);

  const handleScrollToRow = (identifier) => {
    const targetRow = document.getElementById(identifier);
    if (targetRow) {
      targetRow.scrollIntoView({ behavior: "smooth", block: "nearest" });
    }
  };
  return (
    <div className="inventory-container" id="inventory-id">
      <InventoryHeader businessId={businessId} show={show} />
      {show && (
        <DropdownAndAutocomplete
          data={inventoryData}
          onResultClick={handleScrollToRow}
        />
      )}
      <div style={{ display: "flex", alignItems: "center" }}>
        <ShowHide show={show} setShow={setShow} />
        {show && (
          <EPRBox
            businessId={businessId}
            mainBusinessId={mainBusinessId}
            category={"Inventory"}
          />
        )}
        <div style={{ position: "absolute", bottom: "30px", right: "14%" }}>
          <FlowNumbersBox isNormal={true} number={"Flow 5"} color={"#193666"} />
        </div>
      </div>

      {show && <InventoryCustom businessId={businessId} />}
      {show && <InventoryVehicle businessId={businessId} />}
      {show && <InventoryMachinery businessId={businessId} />}
      {show && <InventoryBuilding businessId={businessId} />}
      {show && <InventoryPurchasedService businessId={businessId} />}
      {show && <InventoryIngoingPackaging businessId={businessId} />}
      {show && <InventoryPurchasedPackaging businessId={businessId} />}
      {show && <InventoryChemical businessId={businessId} />}
    </div>
  );
};

export default InventoryComponent;
